// 英文语言包
export default {
  // 通用文本
  common: {
    loading: 'Loading...',
    error: 'Error occurred',
    success: 'Success',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    refresh: 'Refresh',
    close: 'Close',
    open: 'Open',
    yes: 'Yes',
    no: 'No',
    currentLanguage: 'Current Language',
    userAvatar: 'User Avatar',
    icon: 'Icon',
    arrow: 'Arrow',
    impact: 'Impact',
    detail: 'Details',
    foodImage: 'Food Image',
    codedImage: 'Custom Health Image',
    volume: 'Volume',
    robot: 'AI Robot',
    assistant: 'AI Assistant',
    aiAvatar: 'AI Avatar',
    soundIcon: 'Sound Icon',
    keyboard: 'Keyboard',
    voice: 'Voice',
    send: 'Send'
  },

  reportNavigation: {
    label: 'Report navigation',
    home: 'Back to report home',
    monthlyReport: 'Monthly Report',
    tongueReport: 'Tongue Report',
    failed: 'Unable to go back. Please try again.'
  },

  // 页面标题
  titles: {
    home: 'Health Report',
    overview: 'Data Overview',
    details: 'Details',
    nutrition: 'Nutrition',
    nutritions: 'Nutrition',
    tissue: 'Organs',
    assess: 'Wellness Status',
    scheme: 'Wellness Plan',
    recuperate: 'Wellness',
    condition: 'Plan Details',
    compare: 'Comparison',
    microelement: 'Trace Elements',
    aiQuestionnaire: 'AI Survey',
    reportNumber: 'Report ID',
    healthReport: 'Health Report',
    detectionReport: 'Health Screen',
    // Overview 页面特有标题
    bodyHealthInfo: 'Health Summary',
    comprehensiveDataReport: 'Health Assessment',
    dataDisclaimer: 'For wellness guidance only - not medical advice',
    constitutionAssessment: 'Health Status',
    constitutionAssessmentSubtitle: '(Based on current data, for reference)',
    nutritionAssessment: 'Nutrition',
    constitutionEvaluation: 'Health Status',
    bodyAssessment: 'Physical Health',
    nutritionDataReport: 'Nutrition Data',
    bodyOrgansDataReport: 'Organ Health',
    bodyComprehensiveDataReport: 'Health Overview'
  },

  // 健康相关
  health: {
    // 健康指标
    indicators: {
      liver: 'Liver Function',
      kidney: 'Kidney Function',
      heart: 'Heart Function',
      lung: 'Lung Function',
      spleen: 'Spleen Function',
      stomach: 'Stomach Function',
      intestine: 'Intestinal Function',
      brain: 'Brain Function',
      bone: 'Bone',
      muscle: 'Muscle',
      blood: 'Blood',
      immune: 'Immune System',
      endocrine: 'Endocrine System',
      nervous: 'Nervous System',
      reproductive: 'Reproductive System',
      urinary: 'Urinary System'
    },
    
    // 健康状态
    status: {
      normal: 'Normal',
      abnormal: 'Abnormal',
      excellent: 'Excellent',
      good: 'Good',
      average: 'Average',
      fair: 'Fair',
      poor: 'Poor',
      critical: 'Critical',
      improving: 'Improving',
      stable: 'Stable',
      declining: 'Declining',
      // 器官状态相关
      healthy: 'Healthy',
      subHealth: 'Sub-health',
      warning: 'Warning',
      risk: 'Risk',
      attention: 'Alerting',
      maintain: 'Maintain',
      strengthen: 'Strengthen',
      improve: 'Improve'
    }
  },

  // 营养相关
  nutrition: {
    // 营养素名称
    items: {
      vitaminA: 'Vitamin A',
      vitaminB1: 'Vitamin B1',
      vitaminB2: 'Vitamin B2',
      vitaminB6: 'Vitamin B6',
      vitaminB12: 'Vitamin B12',
      vitaminC: 'Vitamin C',
      vitaminD: 'Vitamin D',
      vitaminE: 'Vitamin E',
      vitaminK: 'Vitamin K',
      folicAcid: 'Folic Acid',
      niacin: 'Niacin',
      biotin: 'Biotin',
      calcium: 'Calcium',
      iron: 'Iron',
      zinc: 'Zinc',
      magnesium: 'Magnesium',
      phosphorus: 'Phosphorus',
      potassium: 'Potassium',
      sodium: 'Sodium',
      selenium: 'Selenium',
      copper: 'Copper',
      manganese: 'Manganese',
      iodine: 'Iodine',
      chromium: 'Chromium',
      molybdenum: 'Molybdenum'
    },
    
    // 营养页面相关
    sections: {
      dynamicDataTracking: 'Dynamic Data Tracking',
      bodyAssociatedItems: 'Body Associated Items',
      dietaryRecommendations: 'Dietary Recommendations',
      exerciseRecommendations: 'Exercise Recommendations',
      lifestyleRecommendations: 'Lifestyle Recommendations',
      projectDescription: 'Project Description',
      foodSources: 'Food Sources'
    },
    
    // 营养建议相关
    recommendations: {
      dietary: 'Dietary Recommendations',
      exercise: 'Exercise Recommendations',
      lifestyle: 'Lifestyle Recommendations',
      dailyRoutine: 'Daily Routine Recommendations'
    },
    
    // 营养建议通用术语
    terms: {
      increase: 'Increase',
      decrease: 'Decrease',
      maintain: 'Maintain',
      avoid: 'Avoid',
      consume: 'Consume',
      supplement: 'Supplement',
      balance: 'Balance',
      moderate: 'Moderate',
      daily: 'Daily',
      weekly: 'Weekly',
      morning: 'Morning',
      afternoon: 'Afternoon',
      evening: 'Evening',
      beforeMeals: 'Before Meals',
      afterMeals: 'After Meals',
      fruits: 'Fruits',
      vegetables: 'Vegetables',
      proteins: 'Proteins',
      carbohydrates: 'Carbohydrates',
      fats: 'Fats',
      fiber: 'Fiber',
      water: 'Water',
      exercise: 'Exercise',
      rest: 'Rest',
      sleep: 'Sleep',
      stress: 'Stress',
      relaxation: 'Relaxation'
    }
  },

  // 图表相关
  charts: {
    // 图表元素
    elements: {
      initialValue: 'Initial Value',
      finalValue: 'Final Value',
      currentValue: 'Current Value',
      targetValue: 'Target Value',
      averageValue: 'Average Value',
      maxValue: 'Maximum Value',
      minValue: 'Minimum Value',
      trend: 'Trend',
      comparison: 'Comparison',
      percentage: 'Percentage',
      score: 'Score',
      level: 'Level',
      range: 'Range',
      unit: 'Unit',
      dynamicDataTracking: 'Dynamic Data Tracking',
      nutritionAssociation: 'Nutrition Association',
      organAssociation: 'Organ Association',
      mainAssociationRatio: 'Main Association Ratio',
      
      // 图例相关
      actualValue: 'Actual Value',
      standardValue: 'Standard Value',
      normalValue: 'Normal Value',
      excellentIndicator: 'Excellent Indicator',
      needAttention: 'Need Alerting',
      excellent: 'Excellent',
      
      // CircleProgress组件相关
      exceedUsers: 'Exceed National Users',
      bodyStatus: 'Body Status',
      
      // GaugeCard组件相关
      nutritionBalanceIndicator: 'Nutrition Balance Indicator',
      nutritionStatus: 'Nutrition Status',
      imbalance: 'Imbalance',
      insufficient: 'Insufficient',
      moderate: 'Moderate',
      good: 'Good',
      attention: 'Alerting',
      
      // WaterfallCard组件相关
      nutritionVitalityTip: 'Nutrition Vitality Tip',
      warningTip: 'Warning Tip',
      qualifiedItems: 'Qualified Items',
      abnormalValue: 'Abnormal Value',
      
      // 提示框相关
      standard: 'Standard',
      measured: 'Measured',
      value: 'Value',
      status: 'Status'
    }
  },

  // 数据概览相关
  dataOverview: {
    detectionItem: 'Detection Item',
    initialValue: 'Initial Value',
    finalValue: 'Final Value',
    averageValue: 'Average Value',
    loadingText: 'Loading...',
    vitamins: 'Vitamins',
    microelements: 'Trace Elements',
    minerals: 'Minerals',
    warningCount: 'Warning Items',
    qualifiedCount: 'Qualified Items',
    bodyDynamicChart: 'Body Comprehensive Detection Dynamic Chart',
    organDynamicChart: 'Body Organs Detection Dynamic Chart',
    nutritionDynamicChart: 'Nutrition Detection Dynamic Chart',
    averageStatusChart: 'Average Status Chart',
    bodyAverageStatusChart: 'Body Comprehensive Average Status Chart',
    organAverageStatusChart: 'Body Organs Average Status Chart',
    nutritionAverageStatusChart: 'Nutrition Average Status Chart',
    comprehensiveDataTable: 'Comprehensive Data Report Table',
    organDataTable: 'Body Organs Data Report Table',
    nutritionDataTable: 'Nutrition Data Report Table',
    // Nutritions 页面专用
    nutritionStatusChart: 'Nutrition Status Chart',
    detailedDataReportTable: 'Detailed Data Report Table',
    nutritionConditioningAdvice: 'Nutrition Conditioning Advice'
  },

  // 操作按钮
  actions: {
    viewDetails: 'Details',
    viewMore: 'More',
    startQuestionnaire: 'Start Survey',
    downloadReport: 'Download',
    downloadPdfReport: 'Download PDF Report',
    shareReport: 'Share',
    printReport: 'Print',
    exportData: 'Export',
    compareReports: 'Compare',
    scheduleAppointment: 'Book',
    contactDoctor: 'Contact GP',
    viewHistory: 'History',
    updateProfile: 'Update',
    viewHealthInfo: 'Health Summary',
    customSolution: 'Get Plan',
    viewFullHealthInfo: 'Full Summary',
    exerciseRecommendation: 'Exercise',
    lifestyleRecommendation: 'Lifestyle',
    bodyAssociatedItems: 'Related Health',
    nutritionAssociatedItems: 'Related Nutrition',
    view: 'View',
    expandMore: 'More',
    collapse: 'Less'
  },

  // 调理方案相关
  conditioning: {
    scheme: 'Plan',
    schemeList: 'Plans',
    conditioningPlan: 'Plan',
    conditioningDetails: 'Details',
    conditioningAdvice: 'Guidance',
    conditioningRecommendation: 'Tips',
    viewScheme: 'View',
    viewConditioning: 'View Plan',
    planDescription: 'Overview',
    planDetails: 'Details',
    implementationPlan: 'Guide',
    conditioningMethod: 'Method',
    expectedEffect: 'Benefits',
    attentionMatters: 'Notes',
    usageDuration: 'Duration',
    dosageInstructions: 'Usage',
    // Recuperate页面专用
    specialConditioningProject: 'Special Programme',
    conditioningExplanation: 'Overview',
    conditioningCycle: 'Duration',
    bodyMainConditioningItems: 'Key Health Areas',
    nutritionMainConditioningItems: 'Key Nutrition',
    improvementProjectComparison: 'Progress',
    detailedDataReportTable: 'Health Data',
    detectionItem: 'Indicator',
    averageValue: 'Average',
    lastDetection: 'Previous',
    currentDetection: 'Current',
    specialAttention: 'Alerting'
  },

  // 评估页面相关
  assessment: {
    title: 'Conditioning Status Assessment',
    improvementProjectChart: 'Improvement Project Comparison Chart',
    awaitImprovementChart: 'Awaiting Improvement Project Comparison Chart',
    dynamicComparisonChart: 'Dynamic Comparison Chart',
    interpretationTitle: 'Interpretation Guide',
    lastDetection: 'Last Detection',
    currentDetection: 'Current Detection',
    lastInitialValue: 'Last Initial Value',
    lastFinalValue: 'Last Final Value',
    currentInitialValue: 'Current Initial Value',
    currentFinalValue: 'Current Final Value'
  },

  // 对比页面相关
  comparison: {
    title: 'Health Assessment Comparison',
    before: 'Before',
    after: 'After',
    improvementProjectChart: 'Improvement Project Comparison Chart',
    awaitImprovementChart: 'Awaiting Improvement Project Comparison Chart',
    dynamicComparisonChart: 'Dynamic Comparison Chart',
    comparisonDataReportTable: 'Comparison Data Report Table',
    interpretationTitle: 'Interpretation Guide',
    previousDetection: 'Previous Detection',
    laterDetection: 'Later Detection',
    previousInitialValue: 'Previous Initial Value',
    previousFinalValue: 'Previous Final Value',
    laterInitialValue: 'Later Initial Value',
    laterFinalValue: 'Later Final Value',
    detectionItem: 'Detection Item',
    comparisonResult: 'Comparison Result',
    improved: 'Improved',
    needsImprovement: 'Needs Improvement'
  },

  // 器官页面相关
  tissue: {
    projectDescription: 'Project Description',
    dynamicTrackingMode: 'Dynamic Tracking Mode',
    averageStatusChart: 'Average Status Chart',
    bodyAssociatedItems: 'Body Associated Items',
    dietaryRecommendations: 'Dietary Recommendations',
    exerciseRecommendations: 'Exercise Recommendations',
    lifestyleRecommendations: 'Lifestyle Recommendations',
    interpretationGuide: 'Interpretation Guide'
  },

  // 用户信息相关
  user: {
    height: 'Height',
    weight: 'Weight',
    age: 'years old',
    bmi: 'BMI',
    bodyFatRatio: 'Body Fat Ratio',
    obesityIndex: 'Obesity Index',
    heightUnit: 'cm',
    weightUnit: 'kg',
    bodyFatUnit: '%',
    defaultName: 'John Doe'
  },

  // 健康状态相关
  healthStatus: {
    lifeFeature: 'Exceeds National Users',
    bodyCondition: 'Body Condition',
    healthy: 'Healthy',
    good: 'Good',
    abnormal: 'Abnormal',
    nutritionRisk: 'Nutritional Imbalance Risk',
    healthRisk: 'Health Risk Alert (Organ Indicators)',
    noAbnormalRisk: 'No Abnormal Risk Found',
    noAbnormalRiskFound: 'No Abnormal Risk Found'
  },

  // 弹窗相关
  dialogs: {
    interpretTitle: 'Interpretation Guide',
    lifeFeatureTitle: 'Exceeds National Users',
    lifeFeatureDesc: 'Indicates what percentage of national users your health status exceeds. The higher the value, the better your physical condition.',
    bodyConditionTitle: 'Body Condition',
    bodyConditionDesc: 'Refers to the comprehensive assessment of all internal organs and tissues throughout the body.',
    bodyConditionHealthy: 'Healthy: Body condition is at its best, with all functions operating well.',
    bodyConditionGood: 'Good: Body condition is normal, but there is still room for improvement.',
    bodyConditionAbnormal: 'Abnormal: Body condition is abnormal, with possible discomfort or dysfunction.',
    bodyConditionHealthyDesc: 'Body condition is at its best, with all functions operating well.',
    bodyConditionGoodDesc: 'Body condition is normal, but there is still room for improvement.',
    bodyConditionAbnormalDesc: 'Body condition is abnormal, with possible discomfort or dysfunction.',
    riskTitle: 'Risk Description',
    riskDesc: 'Nutritional balance index ranges from 0 to 1, with higher values indicating better nutritional status. Imbalanced (below 0.3), Normal (0.3-0.7), Well-Done (above 0.7).'
  },

  home: {
    messages: {
      openInMiniProgram: 'Please open this in the mini program',
      notInWechat: 'Error: not in WeChat, unable to return',
      notInMiniProgram: 'Error: not in a mini program, unable to return',
      notInMiniProgramWebview: 'Error: not in a mini program web-view, unable to return',
      returnSoon: 'Returning to the third-party mini program',
      returnFailed: 'Return failed: {message}'
    }
  },

  // 分享相关
  share: {
    dialogTitle: 'Share QR Code',
    imageAlt: 'Share QR Code',
    loadImageFailed: 'Failed to load image: {message}'
  },

  // 一键定制抽屉相关
  customSolutionDrawer: {
    titleMain: 'Please share your current health status',
    titleSub: 'AI will adjust the formula, avoid contraindications, and provide a personalized product plan',
    singleSectionTitle: 'Your current status (single choice)',
    multiSectionTitle: 'Do any of the following apply? (optional, multiple choice)',
    submitting: 'Submitting...',
    submit: 'Confirm and generate a safe plan',
    loadFailed: 'Failed to load, please try again',
    submitFailed: 'Submission failed, please try again'
  },

  // 一键定制加载页相关
  customSolutionLoader: {
    title: 'Based on your current health status',
    subtitle: 'We are building a personalized daily nutrition plan for you'
  },

  // 月报页面相关
  monthlyReport: {
    trendTitle: 'Monthly Health Score Trend',
    highestPoint: 'Highest Point',
    lowestPoint: 'Lowest Point',
    averagePoint: 'Average Score',
    dailyAverage: '(daily avg)',
    aiInterpretation: 'AI Insight:',
    monitoringStatsTitle: 'Your {month} Monthly Monitoring Stats',
    daysUnit: 'days',
    effectiveDays: 'Valid monitoring days this month',
    monitoringTrack: 'Monitoring Track ({days} days)',
    focusTitle: 'Health Focus This Period',
    declineTitle: 'Key Focus This Period',
    declineSubtitle: 'Decline Phase',
    riseTitle: 'Highlights This Month',
    riseSubtitle: 'Recovery Phase',
    insightLabel: 'AI Insight:',
    totalScore: 'Total Score',
    constitution: 'Constitution',
    nutrition: 'Nutrition',
    improvementPathTitle: 'Your Next 30-Day Improvement Path',
    improvementPathSubtitle: "Based on this period's review, your next 30 days are becoming clearer:",
    disclaimer1: 'This report and all suggestions are not medical diagnoses and are for health trend reference only.',
    disclaimer2: 'They cannot replace diagnosis or treatment from professional medical institutions.',
    loadingStages: {
      stage1Title: 'Reviewing this month\'s monitoring data',
      stage1Subtitle: 'Checking continuity across 4 weekly slices',
      stage2Title: 'AI is running a multidimensional attribution analysis',
      stage2Subtitle: 'Scanning links across 16 constitutions and 26 nutrients',
      stage3Title: 'Identifying key health events',
      stage3Subtitle: 'Analyzing trend curves and fluctuation risks',
      stage4Title: 'Report ready',
      stage4Subtitle: 'Redirecting...'
    },
    messages: {
      notInWechat: 'Error: not in WeChat, unable to return',
      notInMiniProgram: 'Error: not in a mini program, unable to return',
      notInMiniProgramWebview: 'Error: not in a mini program web-view, unable to return',
      returnSoon: 'Returning to the third-party mini program',
      returnFailed: 'Return failed: {message}',
      submitFailed: 'Submission failed, please try again later',
      openInWechat: 'Please open this page in WeChat',
      navigateFailed: 'Navigation failed, please try again later',
      lowestValue: 'Lowest Value',
      highestValue: 'Highest Value'
    }
  },

  // 检测要求和注意事项
  requirements: {
    title: 'Important Information & Disclaimers',
    item1: '1. This device is a highly sensitive, personalised system that dynamically tracks your health by combining our data with clinical reports and information you provide. To enable dynamic tracking, you must complete the initial health questionnaire and provide any clinical blood test results. Failing to provide this information will disable this feature, so please fill it in carefully.',
    item2: '2. The risk alerts in your report are based on a real-time analysis of your latest data. Using AI, we identify potential health trends by analysing the connections between your body\'s systems. These alerts indicate a potential trend towards a certain condition; they do not represent your entire disease risk, nor do they confirm you are currently ill. Because our device is highly sensitive and designed for early warnings, it may flag potential risks not yet identified by a clinical diagnosis. For a complete picture, you should monitor your health multiple times and always discuss the results with your doctor for further analysis.',
    item3: '3. The data in your report is a snapshot of your body\'s condition at that specific moment. Your results will naturally vary between tests because they are influenced by many factors, including your sleep, exercise, mental state, environment, and any medication. For this reason, we recommend monitoring your health regularly over time. Gathering more data helps to identify patterns, leading to more accurate insights.',
    item4: '4. All information and advice provided by the AI Assistant is generated based on your test data and public health knowledge. It is for general health reference only and must not be used as a direct basis for diagnosis or treatment. If you feel unwell or have any health concerns, please consult a qualified medical professional promptly.'
  },

  // AI解读相关
  aiInterpret: {
    title: 'AI Nutritionist Health Overview',
    titleHighlight: 'AI Nutritionist',
    titleSuffix: 'Health Overview',
    keyResults: 'Key Monitoring Results',
    affectedConstitution: 'Potentially Affected Body Constitution',
    importantTip: 'Important Notice: Multiple Nutritional Deficiencies',
    multipleDeficiency: 'Multiple severe nutritional deficiencies detected, which may affect important organ functions',
    noKeyResults: 'No key monitoring results data available',
    analyzing: 'Conducting in-depth analysis, please wait a moment',
    generating: 'AI is generating summary...',
    currentLevel: 'Current level only',
    normalRange: 'Normal range'
  },

  // 营养活力卡片相关
  nutritionVitality: {
    title: 'Nutrition Vitality Tips',
    needAttention: 'Need Alerting',
    excellentIndicator: 'Excellent Indicator'
  },

  // 饮食建议相关
  dietAdvice: {
    title: 'AI Conditioning Advice',
    recentDietAdvice: 'Recent Dietary Advice',
    notRecommendedFoods: 'Foods to Limit',
    recommendedFoods: 'Foods to Include',
    reduceIntake: 'We suggest cutting back on these',
    recommendedSupplement: 'We recommend adding these',
    noNotRecommendedFoods: 'No not recommended foods found',
    lifestyleImprovement: 'Lifestyle Improvement Suggestions',
    dietAdviceDialog: 'Conduct daily food adaptability tests, follow daily recommended diet with regular timing and quantity, comprehensive balance, and strictly prohibit consumption of intolerant foods.'
  },

  // AI助手相关
  aiAssistant: {
    title: 'AI Assistant',
    disclaimer: 'For wellness guidance only - consult your GP for health concerns.',
    welcomeMessage: 'Hi! I\'m here to help with your health assessment.\nAsk me anything about your results.',
    inputPlaceholder: 'Ask me about your health',
    holdToSpeak: 'Hold to Speak',
    speakingTimeTooShort: 'Speaking time too short',
    waitForAIComplete: 'Please wait for AI analysis to complete before using chat function',
    responseNotComplete: 'Response not complete, please wait~',
    noMoreHistory: 'No more history messages',
    loadingMore: 'Loading more...',
    recordingCancelled: 'Recording cancelled',
    recordingFailed: 'Recording failed, please try again',
    voiceRecognitionFailed: 'Voice recognition failed, please try again',
    noSpeechDetected: 'No speech detected, please try again',
    releaseToCancel: 'Release to Cancel',
    releaseToSend: 'Release to Send, Slide up to Cancel',
    errorResponse: 'Sorry, unable to answer (network or question limitation). Suggestions:\n 1. Try again later \n2. Check network \n3. Try different phrasing \n',
    recordingStartFailed: 'Recording failed to start, please check permissions: ',
    microphonePermissionRequired: 'Microphone permission required to use voice function',
    miniProgramInitializing: 'Mini program initializing, please try again later',
    wechatInitializing: 'WeChat function initializing, please try again later',
    wechatSDKInitFailed: 'WeChat SDK initialization failed, please refresh and try again',
    wechatVersionNotSupported: 'Current WeChat version does not support recording function',
    grantMicrophonePermission: 'Please grant microphone permission',
    recordingProcessFailed: 'Recording processing failed',
    recordingStopFailed: 'Recording stop failed, please try again',
    recordingNotSupported: 'Current environment does not support recording function',
    recordingDataError: 'Recording data error, please try again',
    stopRecordingIn: 'Stop recording in {seconds}s'
  }
}
